import React, { useEffect, useState } from "react"
import SyntaxHighlighter from "react-syntax-highlighter"
// import { dark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { Clipboard } from "react-feather"
//import Select from 'react-select'
import { CopyToClipboard } from "react-copy-to-clipboard"
import { Popover, Whisper } from "rsuite"
//import 'rsuite/lib/styles/index.css'
//import 'rsuite/dist/styles/rsuite-default.css'
import "rsuite/lib/Popover/styles/index.less"

const speaker = (
  <Popover title="" style={{ width: "100px" }}>
    Click to copy
  </Popover>
)

const copiedSpeaker = (
  <Popover title="" style={{ width: "100px" }}>
    Copied
  </Popover>
)

const customStyles = {
  control: (styles, state) => ({
    ...styles,
    color: "#989a9c",
    backgroundColor: "#fff0",
    border:
      state.isFocused || state.isSelected
        ? "1px solid #e4e4e4 !important"
        : "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "all 100ms ease 0s",
    fontSize: "0.75rem",
    fontWeight: "400",
    letterSpacing: "0.5px",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: "#989a9c",
    width: "14px",
  }),
  menu: (styles, state) => ({
    ...styles,
    background: "#ffffff",
  }),
  menuList: (styles, state) => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (provided, state) => ({
    ...provided,
    background:
      state.isFocused || state.isDisabled || state.isSelected
        ? "#3a414a"
        : "#ffffff",
    color: state.isSelected ? "#989a9c" : "#989a9c",
    padding: "5px 15px",
    cursor: "pointer",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#989a9c",
  }),
}

const CodeBlock = ({
  code,
  title,
  exampleLanguages,
  selectedLanguage,
  handleLanguageSelect,
  hasLanguageSelector = true,
  hasCopyCodeButton = true,
  hasMultipleLanguages = false,
  clipBoardButtonSize = 20,
  showLineNumbers = false,
  defaultSelectedTab = "json",
  ...props
}) => {
  const [localSelectedLanguage, setLocalSelectedLanguage] = useState()
  const [isCopied, setIsCopied] = useState(false)
  const [codeFormat, setCodeFormat] = useState()
  const [finalCode, setFinalCode] = useState()

  useEffect(() => {
    setLocalSelectedLanguage(selectedLanguage)

    if (hasMultipleLanguages) {
      let getCode = getCodeExample(code)
      setFinalCode(getCode.code)
      setCodeFormat(getCode.format)
    } else {
      setFinalCode(code)
      setCodeFormat(defaultSelectedTab)
    }
  }, [selectedLanguage])

  const getCodeExample = code1 => {
    return code1.find(element => {
      if (
        localSelectedLanguage &&
        localSelectedLanguage.hasOwnProperty("value")
      ) {
        if (localSelectedLanguage.value === element.lang) {
          // return element
        }
        return localSelectedLanguage.value === element.lang
      }

      return selectedLanguage.value === element.lang
    })
  }

  /*let finalCode = code
  let codeFormat = defaultSelectedTab

  if (hasMultipleLanguages) {
    let filteredCode = getCodeExample(code)
    finalCode = filteredCode.code
    codeFormat = filteredCode.format
  } else {
    finalCode = code
    codeFormat = defaultSelectedTab
  }*/

  const selectLanguage = language => {
    setLocalSelectedLanguage(language)

    if (hasMultipleLanguages) {
      let getCode = code.find(element => {
        return language.value === element.lang
      })
      setFinalCode(getCode.code)
      setCodeFormat(getCode.format)
    } else {
      setFinalCode(code)
      setCodeFormat(defaultSelectedTab)
    }
  }

  return (
    <div
      className={`code-example-box ${hasLanguageSelector ? "" : "no-header"}`}
      style={props.boxStyle}
    >
      {localSelectedLanguage && (
        <>
          {hasLanguageSelector && (
            <div className="box-header">
              <div className="box-title">
                {exampleLanguages &&
                  exampleLanguages.length > 0 &&
                  exampleLanguages.map(language => (
                    <span
                      className={
                        language.value === localSelectedLanguage.value
                          ? "selected"
                          : ""
                      }
                      onClick={() => {
                        // handleLanguageSelect(language)
                        selectLanguage(language)
                      }}
                    >
                      {language.label}
                    </span>
                  ))}
              </div>
            </div>
          )}
          {finalCode && (
            <div className="box-body">
              {hasCopyCodeButton && (
                <div className="copy-code">
                  {/* <div class="copy-code-divider"></div> */}
                  <div className="clipboard">
                    <CopyToClipboard
                      text={finalCode}
                      onCopy={() => {
                        setIsCopied(true)
                      }}
                    >
                      <Whisper
                        placement="topEnd"
                        trigger="hover"
                        speaker={isCopied ? copiedSpeaker : speaker}
                        onExited={() => {
                          setIsCopied(false)
                        }}
                      >
                        <Clipboard
                          color="grey"
                          size={clipBoardButtonSize}
                          className="code-icon"
                        />
                      </Whisper>
                    </CopyToClipboard>
                  </div>
                </div>
              )}
              <SyntaxHighlighter
                language={codeFormat}
                showLineNumbers={showLineNumbers}
                wrapLines={true}
              >
                {finalCode}
              </SyntaxHighlighter>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default CodeBlock
